<template>
  <div>
    <el-dialog
      title="审核"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
      v-dialogDrag
      @close="close"
    >
      <el-form
        :model="dataObj"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-position="right"
        label-width="90px"
      >
        <el-form-item label="是否通过" prop="status">
          <el-select
            v-model="dataObj.status"
            clearable
            placeholder="请选择"
            class="input-width"
          >
            <el-option
              v-for="(val, i) in ['审核通过', '驳回申请']"
              :label="val"
              :value="i + 1"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="驳回原因"
          prop="rejectExplain"
          v-if="dataObj.status == 2"
        >
          <el-input
            type="textarea"
            :rows="4"
            v-model="dataObj.rejectExplain"
            placeholder="请输入"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" v-preventReClick="5000" :disabled="disabled"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="checkAdd('ruleForm')"
          v-preventReClick="5000"
          :disabled="disabled"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * Amazon 退款审核弹窗
 * 功能：选择审核通过/驳回并填写驳回原因后调用 Amazon 退款审核接口。
 * 备注：组件 name 为 "add"，疑似复制残留命名。
 */
import { auditAmazonRefundOrder } from "@/api/user";
export default {
  name: "add",
  props: {
    refundInfo: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      // 按钮禁用状态（定义了但从未改变，限流靠 v-preventReClick）
      disabled: false,
      // 弹窗显示状态
      dialogFormVisible: true,
      // 审核提交数据（退款信息/审核结果/驳回原因）
      dataObj: {
        refundInfo: [],
        status: 1,
        rejectExplain: "",
      },
      rules: {
        status: [
          { required: true, message: "请选择是否审核通过", trigger: "blur" },
        ],
        rejectExplain: [
          { required: true, message: "请填写驳回原因", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    /** 关闭弹窗并通知父组件 */
    close() {
      this.dialogFormVisible = false;
      this.$emit("isShowEdit");
    },
    /** 校验表单后提交审核结果，成功后关闭弹窗并刷新列表
     * @param {String} formName 表单 ref 名称
     */
    checkAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataObj.refundInfo = this.refundInfo;
          auditAmazonRefundOrder(this.dataObj).then((result) => {
            if (result.code == 200) {
              this.dialogFormVisible = false;
              this.$message.success(result.msg);
              this.$emit("getList");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>